export default __webpack_public_path__ + "static/woman1-0ffc4f41110fcfaa0d729447a61e6baa.webp";